import React from "react";
import PropTypes from 'prop-types'
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../Utils/lib";

const Errors = ({errors}) => {
    const userLanguage = useSelector(state => state.app.userLanguage);
    return (
        <div>
            {errors.map((err, index) => {
                return (
                    <p key={index}
                       style={{color: "red", margin: 0}}
                    >
                        Column {multiLanguageValue(err.label, userLanguage)} is required
                    </p>
                )
            })}
        </div>
    )
};
export default Errors

Errors.propTypes = {
    errors: PropTypes.array
};